import React from 'react'
import Slider from 'react-slick'
import { Card, Button } from 'semantic-ui-react'
import ButtonAction from './Button'
import ProgressBar from './ProgressBar';
import arrow_right from '../../img/send-message-btn-mobile.png'
import arrow_left from '../../img/send-message-btn-mobile-left.png'

function SampleNextArrow(props) {
  const { className, style, onClick } = props
  return (
    <div
      className={className}
      style={{
        ...style,
        display: 'block',
        zIndex: '10',
        right: '0',
        backgroundImage: `url(${arrow_right})`
      }}
      onClick={onClick}
    />
  )
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props
  return (
    <div
      className={className}
      style={{
        ...style,
        display: 'block',
        zIndex: '10',
        left: '0',
        backgroundImage: `url(${arrow_left})`
      }}
      onClick={onClick}
    />
  )
}


function computeButtons(buttons) {
  return (
    <Button.Group fluid>
      {
        buttons.map((button, i) => (
          <ButtonAction
            button={button}
            key={i}
          />
        ),
        )
      }
    </Button.Group>
  )
}

function computeBilanButtons(buttons) {
  return (
    <Button.Group basic >
      {
        buttons.map((button, i) => (
          <ButtonAction
            button={button}
            key={i}
          />
        ),
        )
      }
    </Button.Group>
  )
}

/*const header = title => (
  <h3>
    {title}
  </h3>
)
*/
class Carousel extends React.Component {

  componentDidMount() {
    if (this.bilan && this.props.last) {
        const prevContainerChat = this.bilan.parentElement.parentElement.previousSibling;
        const secondRow = prevContainerChat.parentElement.parentElement;
        window.setTimeout(() => {
          secondRow.scrollTop = prevContainerChat.offsetTop + prevContainerChat.offsetHeight - secondRow.offsetTop;
        }, 0);
    } else {
      return;
    }
  }

  render() {

    const message = this.props.message;

      if (message && message.attachments[0] && (message.attachments.length === 1) && message.attachments[0].content.images[0].url) {
        const dataToShow = {
          title: 'En résumé',
          percentage: message.attachments[0].content.images[0].url,
          buttons: message.attachments[0].content.buttons || null,
          description: message.attachments[0].content.text
        };
        return (
          <div className={`bilan bilan_${dataToShow.percentage} ui card`} ref={ref => this.bilan = ref}>
            <div className="content">
              <h3>{dataToShow.title}</h3>
            </div>
            <ProgressBar percentage={dataToShow.percentage} />
            <div className="content">
              <div className="description">{dataToShow.description.split('\n').map((item, key) => <span key={key}>{item}<br /></span>)}</div>
            </div>
            <div className="extra content">{dataToShow.buttons && computeBilanButtons(dataToShow.buttons)}</div>
          </div>
        )
      } else {
        const settings = {
          speed: 500,
          nextArrow: <SampleNextArrow />,
          prevArrow: <SamplePrevArrow />,
          infinite: false,
          arrows: true,
          slidesToScroll: 1,
          // useCSS: true,
          variableWidth: true,
          responsive: [
          {
            breakpoint: 1000,
            settings: {
              slidesToShow: 1,
            }
          },
          {
            breakpoint: 1000000,
            settings: {
              slidesToShow: 3,
            },
          }]
        }
        const attachmentsToShow = message.attachments.filter(attachment => !Number.isInteger(parseInt(attachment.content.images[0].url, 10)));
        return (
          <Slider
          className={`real-carrousel`}
          {...settings}
          >
          {attachmentsToShow
            .map((attachment, i) => (
                <div
                key={i}
                style={{ margin: '10px', height: '100%' }}>
                  <Card
                    image={(attachment.content.images[0].url) && attachment.content.images[0].url}
                    header={attachment.content.title}
                    description={attachment.content.text}
                    extra={attachment.content.buttons && computeButtons(attachment.content.buttons)}/>
                </div>
              ))}
          </Slider>
        )
      }
  }
}


export default Carousel



// WEBPACK FOOTER //
// ./src/views/components/Carousel.js